import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { bucketS3, caminhoAnexosGeneralFiles } from 'constants/EnvironmentData';
import Styled from '../styles/AdminFVContainer.styled';
import AdminFerramentaVideo from '../admin/AdminFerramentaVideo';
import AdminFVContainer from '../admin/AdminFVContainer';
import { YellowButton } from 'components/UI/Buttons';
import { PiVideoFill } from 'react-icons/pi';
import AdminFVPackage from '../admin/AdminFVPackage';
import AdminFVContents from '../admin/AdminFVContents';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
const FVRouter = () => {
    const history = useHistory();
    const getS3BaseUrl = (): string => {
        return bucketS3() + caminhoAnexosGeneralFiles();
    };



    const isPageInitial = () : boolean => {
        return history.location.pathname === '/admin/ferramenta-video';
    };

    const handleLogout = () => {
        // Lógica de logout
        history.push('/admin');
    };
    return (
        <Styled.Container img={isPageInitial() ? getS3BaseUrl() + 'anexo_storage_files_12506864710722349518.png_2025-08-27-1756301229116.png' : undefined}>
            <Styled.DivBetween>
                <Styled.Title>Ferramenta <PiVideoFill /></Styled.Title>
                <YellowButton style={{ width: '200px', borderRadius: '4px' }} onClick={handleLogout}>
                    Sair
                </YellowButton>
            </Styled.DivBetween>
            <Switch>
                <Route exact path="/admin/ferramenta-video" component={AdminFerramentaVideo} />
                <Route exact path="/admin/ferramenta-video/:idContainer" component={AdminFVContainer} />
                <Route exact path="/admin/ferramenta-video/:idContainer/:idPackage" component={AdminFVPackage} />
                <Route exact path="/admin/ferramenta-video/:idContainer/:idPackage/:idUnit" component={AdminFVContents} />
            </Switch>
        </Styled.Container>
    );
};

export default FVRouter;
